import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass, toggleClass } from '@studiometa/js-toolkit/utils';
import { Menu } from '@studiometa/ui';
import LocalizationMenu from './LocalizationMenu/index.js';
import MegaMenu from './MegaMenu.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      LocalizationMenu,
      MegaMenu,
    },
  };

  burgerIsOpen = false;

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 96;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');
  }

  /**
   * toggle burger animation for icon
   */
  toggleBurger() {
    if (this.burgerIsOpen) {
      removeClass(document.documentElement, 'is-menu-open');
      this.burgerIsOpen = false;

      for (const megaMenu of this.$children.MegaMenu) {
        megaMenu.close();
      }
    } else {
      addClass(document.documentElement, 'is-menu-open');
      this.burgerIsOpen = true;
    }
  }
}
